import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  useDisclosure,
  Button,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import TableOpenTtkq from "./tableOpenTtkq";
import toast from "react-hot-toast";
import { exportFile } from "../../utils/tools";
import iconFile from "../../assets/images/apartment/Frame.svg";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconExport from "../../assets/images/product/iconExport.svg";
import PopupImport from "../../components/popup/PopupImport";
import { useTtkq } from "../../hooks/useTtkq";
import { ttkqCall } from "../../api/ttkq";
import TransactionDetailModal from "../../components/transations/TransactionDetailModal";

const columnMappingImportAgentReverse = {
  "Tên dự án": "projectName",
  "Mã căn hộ": "apartmentCode",
  "Ngày đóng TTKQ": "priceTime",
  "Số tiền đóng TTKQ": "price",
  "Phương thức thanh toán": "paymentMethodName",
  "Ghi chú": "note",

  // customer
  "Tên khách hàng hoặc công ty": "customerName",
  "Mã CCCD": "identificationNumber",
  "Mã số thuế": "businessTaxCode",
  // agent
  "Tên đại lý": "agentName",
};

export default function Ttkq() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const transactionModal = useDisclosure();

  const { refetch, isRefetching, entries, ttkqData } = useTtkq();

  const [paramExport, setParamExport] = useState(null);
  const [popupImportAgentVisible, setPopupImportAgentVisible] = useState(false);

  const [transactionApprove, setTransactionApprove] = useState({
    id: null,
    type: null,
    status: null,
    submit: null,
  });

  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    const handleOpenTransactionDetail = (event) => {
      const detail = event.detail || {};

      setTransactionApprove({
        id: detail.id,
        type: detail.type || "TTKQ",
        status: detail.status || "APPROVED",
        submit: detail.submit,
      });

      transactionModal.onOpen();
    };

    window.addEventListener(
      "OPEN_TRANSACTION_DETAIL_MODAL",
      handleOpenTransactionDetail
    );

    return () => {
      window.removeEventListener(
        "OPEN_TRANSACTION_DETAIL_MODAL",
        handleOpenTransactionDetail
      );
    };
  }, [transactionModal]);

  const handleConfirmTransaction = async ({
    transactionDate,
    refetch: refetchDetail,
  }) => {
    if (!transactionApprove?.submit || !transactionApprove?.id) return;

    setConfirmLoading(true);

    try {
      await transactionApprove.submit(
        transactionApprove.status || "APPROVED",
        transactionApprove.id,
        transactionDate
      );

      await refetch();

      if (refetchDetail) {
        await refetchDetail();
      }

      transactionModal.onClose();

      setTransactionApprove({
        id: null,
        type: null,
        status: null,
        submit: null,
      });
    } catch (error) {
      console.log("confirm ttkq transaction error:", error);
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleExportAgentSample = () => {
    const columnMapping = {
      projectName: "Tên dự án",
      apartmentCode: "Mã căn hộ",
      priceTime: "Ngày đóng TTKQ",
      price: "Số tiền đóng TTKQ",
      paymentMethodName: "Phương thức thanh toán",
      note: "Ghi chú",

      // customer
      customerName: "Tên khách hàng hoặc công ty",
      identificationNumber: "Mã CCCD",
      businessTaxCode: "Mã số thuế",
      // agent
      agentName: "Tên đại lý",
    };

    const data = [
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Thanh toán tiến độ/Thanh toán thông thường",
        note: "abc",
        customerName: "Nguyễn Quốc Đạt",
        identificationNumber: "030200007777",
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Vay vốn ngân hàng/Hỗ trợ lãi suất",
        note: "abc",
        customerName: "MSH Group",
        businessTaxCode: "777",
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Thanh toán sớm/Thanh toán nhanh",
        note: "abc",
        customerName: "Phạm Đức Trung",
        identificationNumber: "030200001111",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "MSH Group",
        businessTaxCode: "777",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Thanh toán sớm/Thanh toán nhanh",
        note: "abc",
      },
    ];

    try {
      exportFile(data, columnMapping, "bang_ttkq.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleExport = async () => {
    const checkInColumnMapping = {
      status: "Trạng thái",
      projectName: "Tên dự án",
      apartmentCode: "Mã căn hộ",
      customerName: "Tên khách hàng",
      time: "Ngày ký TTKQ",
      priceTime: "Ngày đóng TTKQ",
      creator: "Người chuyển TTKQ",
      saleBlockName: "Khối",
      saleAreaName: "Vùng",
      createdAt: "Ngày chuyển TTKQ",
      approver: "Người duyệt TTKQ",
      approverDate: "Ngày duyệt TTKQ",
    };

    if (ttkqData?.length) {
      const data = await ttkqCall.export(entries, paramExport);

      if (data) {
        exportFile(data, checkInColumnMapping, "bang_quan_ly_ttkq.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else {
      toast.error("Không có dữ liệu");
    }
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý TTKQ
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExport} />

            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất exel
            </Text>
          </Button>

          <Menu>
            <MenuButton
              w={"180px"}
              h={"44px"}
              as={Button}
              p="10px 16px"
              backgroundImage="var(--color-button)"
              _hover={{
                filter: "brightness(90%)",
              }}
            >
              <Flex alignItems="center" gap="8px" w={"full"}>
                <Image src={IconFile} />

                <Text
                  fontSize="15px"
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Tải file lên
                </Text>
              </Flex>
            </MenuButton>

            <MenuList>
              <MenuItem
                onClick={() => setPopupImportAgentVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import TTKQ đại lý
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>

      <Box mt={{ base: "23px" }}>
        <TableOpenTtkq
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>

      {popupImportAgentVisible && (
        <PopupImport
          isOpen={popupImportAgentVisible}
          onClose={() => setPopupImportAgentVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingImportAgentReverse}
          handleExport={handleExportAgentSample}
          titleAdd="Thêm danh sách TTKQ đại lý"
          inputAdd="Nhập danh sách TTKQ đại lý"
          type={"ttkqAgent"}
          isTypePrice={true}
        />
      )}

      <TransactionDetailModal
        isOpen={transactionModal.isOpen}
        onClose={transactionModal.onClose}
        id={transactionApprove.id}
        type={transactionApprove.type}
        onConfirm={handleConfirmTransaction}
        confirmLoading={confirmLoading}
      />
    </Box>
  );
}